<template>
	    <div>
			<el-dialog title="素材库" :append-to-body="append_body" top="3%" :visible.sync="libDialogVisible" width="65%">
			   <el-row>
				  <el-col :span="24">
						<el-form :inline="true">				
							<el-form-item>
								<el-radio-group v-model="type" size="small">
								  <el-radio-button label="video">视频库</el-radio-button>
								  <el-radio-button label="image" disabled >图片库</el-radio-button>
								</el-radio-group>
							</el-form-item>	
							<el-form-item>
								 <el-input size="small" style="width:150px;" v-model="keyword" placeholder="搜索关键词/ID"></el-input>
							</el-form-item>
							<el-form-item>
								   <el-select v-model="advertiser_id" size="small" placeholder="请选择">
										<el-option
										v-for="item in advertiserList"
										:key="item.value"
										:label="item.label"
										:value="item.value">
										<span style="float: left;font-size:9px;">{{ item.label }}</span>
										<span style="float: right;color:#8492a6;font-size:9px">{{ item.value }}</span>
										</el-option>
									</el-select>
							</el-form-item>																
							<el-form-item>
								<el-button  size="small"><i  class="el-icon-search"></i> 查询</el-button>
							</el-form-item>				
						</el-form>															
					</el-col>
					<div class="card-lists card-lists-vertical material-lib-item" v-loading="listLoading">
					   <el-checkbox-group v-model="sels" style="font-size:14px;">
					   <div class="card-list video-vertical" v-for="item in list">
							 <div class="card-list-wrapper">
								 <div class="card">
									   <div class="card-video">
										   <img :src="item.poster_url" class="j-ignore" @click="viewVideo(item)">
										   <img src="//s1.pstatp.com/bytecom/platform_web/static/image/play.svg?f3db861d10cf31d0ff0778b1b4331ba9" class="video-play-icon" style="width: 30px; height: 30px;"> 
										   <div class="card-duration">{{item.duration}}s</div>
										   <div class="card-checkbox_hw">
										    <el-checkbox :label="item">&nbsp;</el-checkbox></div>
									   </div>
									   <div class="card-desc card-desc-normal"><p>{{item.id}}</p></div>
								   </div>
							  </div>
						</div>
						</el-checkbox-group>
					</div>
					<div style="margin-top:15px;text-align:center;">
					  <el-pagination background layout="prev, pager, next"  @current-change="handleCurrentChange"   :page-size="pagesize" :total="total"></el-pagination>
					</div>
			   </el-row>
				<span slot="footer" class="dialog-footer">
				    <span style="float:left">已选:{{selsNum}}/{{total}}</span>
					<el-button @click="libDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="Confirm">确 认</el-button>
				  </span>
			</el-dialog>
		</div>
</template>
<script>
	import { getLibListPage } from '../../../../api/api';
	export default {		
		props:{
		  
		},		
		data() {
			return {
				sels:[],
				total:0,
				page:1,
				pagesize:12,
				listLoading:false,
				libDialogVisible:false,
				keyword:'',
				value:'',
				type:'video',
				append_body:true,
				list:[],
                advertiserList: []		
			}
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   },
		   selsNum(){
		    return this.sels.length
		   }
		},
		methods: {
		    
			handleCurrentChange(val){
			  this.page = val
			  this.getLibList()
			},
			openModel(){
			 this.libDialogVisible = true
			 this.sels = []
			 this.getLibList()
			},
			viewVideo(item){
			  window.open(item.url)
			},
			Confirm(){
			 this.$emit('func',this.sels)
			 this.libDialogVisible = false
			},
			getLibList(){
			  
			  let para = {
					page: this.page,
					advertiser_id: this.advertiser_id,
					page_size:this.pagesize
				};
				this.listLoading = true;
				getLibListPage(para).then((res) => {
					this.total = res.data.page_info.total_number;
					this.list = res.data.list;
					this.listLoading = false;
				});
			}
		},
		mounted() {
			
		}
	}

</script>
<style  lang="scss">
  .card-list.video-vertical {
    width: 22%;
    margin-right: 16px;
    margin-bottom: 16px;
}
.material-lib-wrapper .material-lib-panel .card-lists .card-list-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    transition: all 0.2s ease;
}
.card-list-wrapper .card {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.card img {
    display: inline-block;
    width: 100%;
	height:200px;
    margin-right: 2px;
}
.card .card-duration {
    width: 46px;
    height: 20px;
    position: absolute;
    top: 4px;
    left: 4px;
    padding: 2px 8px;
    line-height: 16px;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    background: #000;
    opacity: 0.6;
    border: 1px solid rgba(255,255,255,0.6);
}
.card .card-checkbox_hw{
  position: absolute;
  top:4px;
  right:0px;
}
.card-lists .card-list {
    display: inline-block;
    overflow: hidden;
    vertical-align: top;
    position: relative;
}
.card .card-video {
    position: relative;
    width: 100%;
    cursor: pointer;
}
.card .card-video .video-play-icon {
    position: absolute;
    transform: translate(-50%, -50%);
    pointer-events: none;
    top: 50%;
    left: 50%;
}
.material-lib-item {
    border-top: 1px solid #EAEAEA;
    padding: 18px 24px 0;
    height: 408px;

    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    background: #f8f9fa;
}
</style>


// WEBPACK FOOTER //
// lib.vue?c5b4e458